import Callout from "../../../../src/components/callouts/callouts";
import Btn from "../../../../src/components/buttons/buttons";
import List from "../../../../src/components/lists/list";
import Tabs from "../../../../src/components/tabs/tabss";
import Links from "../../../../src/components/links/links";
import { FaUmbrellaBeach, FaHospital, FaUserEdit } from "react-icons/fa";
import TablaComision, { TipoComision } from "../../../../src/components/tablaComision2/tablaComision";
import { PREFIX_REPOSITORY, POSTFIX_REPOSITORY } from "../../../../src/constants/URLs";
import * as React from 'react';
export default {
  Callout,
  Btn,
  List,
  Tabs,
  Links,
  FaUmbrellaBeach,
  FaHospital,
  FaUserEdit,
  TablaComision,
  TipoComision,
  PREFIX_REPOSITORY,
  POSTFIX_REPOSITORY,
  React
};